const de: Record<string, string> = {
  dashboard: 'Dashboard',
  orderBook: 'Auftragsbuch',
  newOffer: 'Neues Angebot',
  myOffers: 'Meine Angebote',
  matches: 'Matches',
  wishlist: 'Wunschliste',
  profile: 'Profil',
  admin: 'Admin',
  logout: 'Abmelden',
  openOffers: 'Offene Angebote',
  totalMatches: 'Matches gesamt',
  feePerMatchLabel: 'Gebühr pro Match',
  completedSwaps: 'Abgeschlossene Swaps',
  newOfferBtn: 'Neues Angebot',
  browseOffers: 'Neues Swap-Angebot erstellen',
  viewMatches: 'Matches anzeigen',
  manageWishlist: 'Wunschliste verwalten',
  search: 'Suchen',
  metal: 'Metall',
  all: 'Alle',
  gold: 'Gold',
  silver: 'Silber',
  platinum: 'Platin',
  palladium: 'Palladium',
  have: 'Ich biete',
  want: 'Ich suche',
  quantity: 'Menge',
  cashAdjustment: 'Barausgleich',
  note: 'Notiz',
  expires: 'Läuft ab',
  accept: 'Akzeptieren',
  counter: 'Gegenangebot',
  delete: 'Löschen',
  pending: 'AUSSTEHEND',
  inTransit: 'IN TRANSIT',
  completed: 'ABGESCHLOSSEN',
  disputed: 'IN STREIT',
  payFee: 'Gebühr bezahlen',
  addTracking: 'Tracking hinzufügen',
  confirmReceipt: 'Empfang bestätigen',
  openDispute: 'Streit öffnen',
  rating: 'Bewertung',
  phone: 'Telefon',
  save: 'Speichern',
  changePassword: 'Passwort ändern',
  currentPassword: 'Aktuelles Passwort',
  newPassword: 'Neues Passwort',
  confirmPassword: 'Passwort bestätigen',
  updatePassword: 'Passwort aktualisieren',
  accountInfo: 'Kontoinformationen',
  shippingAddress: 'Lieferadresse',
  tradingCountries: 'Handelsländer',
  saveAddress: 'Adresse speichern & verifizieren',
  savePreferences: 'Einstellungen speichern',
  allCountries: 'Alle Länder',
  selectCountries: 'Bestimmte Länder auswählen',
  pendingVerification: '⏳ Ausstehend',
  verified: '✓ Verifiziert',
  company: 'Unternehmen',
  country: 'Land',
  email: 'E-Mail',
  iRequest: 'Ich fordere an',
  iOffer: 'Ich biete an',
  marketSnapshot: 'Marktübersicht',
  noRatings: '—',
};

const DACH = ['bullionx.de', 'bullionx.at', 'bullionx.ch'];

export const t = (key: string, fallback?: string): string => {
  const host = window.location.hostname.toLowerCase();
  if (DACH.includes(host) && de[key]) return de[key];
  return fallback || key;
};
